import { Slide } from '@/components/core/Slide';
import videoFile from './16-bubbles.webm';
import audioFile from './90-outro.mp3';

const autoNextDuration = 12000;
const transcript = `
  Hoi, ik ben er nog!...

  Bedankt dat ik weer mee mocht Jonathan, en ik wil jullie bedanken dat jullie er waren en dat ik mocht komen...

  Bedankt! En tot ziens!
`;

// Jonathan: Dank je wel EVA, het was geweldig om je erbij te hebben. En natuurlijk ook dank aan iedereen
// die vandaag aanwezig was. We hopen dat jullie geïnspireerd zijn geraakt door de mogelijkheden van AI
// voor de technieksector.

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      visualizer="full"
      autoNext={autoNextDuration}
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="relative z-10 flex items-center justify-center h-full">
        <h1 className="text-8xl font-light text-white tracking-wider">EVA</h1>
      </div>
    </Slide>
  );
};
